"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _CryptoCompareEDS_axiosInstance;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoCompareEDS = void 0;
const axios_1 = __importDefault(require("axios"));
class CryptoCompareEDS {
    constructor() {
        _CryptoCompareEDS_axiosInstance.set(this, void 0);
        __classPrivateFieldSet(this, _CryptoCompareEDS_axiosInstance, axios_1.default.create({ baseURL: 'https://min-api.cryptocompare.com' }), "f");
    }
    getTokenPrices(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: prices } = yield __classPrivateFieldGet(this, _CryptoCompareEDS_axiosInstance, "f").get('/data/pricemultifull', {
                params: {
                    fsyms: params.tokens.map(token => token.symbol).join(','),
                    tsyms: 'USD',
                },
            });
            return Object.entries(prices.RAW).map(([symbol, priceObject]) => {
                const usdPrice = priceObject.USD.PRICE;
                const token = params.tokens.find(token => token.symbol === symbol);
                return {
                    usdPrice,
                    token,
                };
            });
        });
    }
    getTokenPriceHistory(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const path = `/data/${params.type === 'hour' ? 'histohour' : 'histoday'}`;
            const response = yield __classPrivateFieldGet(this, _CryptoCompareEDS_axiosInstance, "f").get(path, {
                params: {
                    fsym: params.token.symbol,
                    tsym: 'USD',
                    limit: params.limit,
                },
            });
            const history = [];
            response.data.Data.forEach(data => {
                history.push({
                    usdPrice: data.close,
                    timestamp: data.time,
                    token: params.token,
                });
            });
            return history;
        });
    }
    getCurrencyRatio(currency) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield axios_1.default.get(`https://api.flamingo.finance/fiat/exchange-rate?pair=USD_${currency}`);
            return data;
        });
    }
}
exports.CryptoCompareEDS = CryptoCompareEDS;
_CryptoCompareEDS_axiosInstance = new WeakMap();
